<div *ngIf="data" class="button-bar-container">
  <div class="hint-text">
    {{ 'button-bar-for-continue-booking.text.continue-booking' | translate }}
  </div>
  <lib-spacer [height]="5"></lib-spacer>

  <div class="content-container">
    <div>
      <h2>{{ data?.businessObject?.name }}</h2>
      <div class="hint-text">{{ data?.businessObject?.address }}</div>
    </div>

    <lib-spacer [height]="10"></lib-spacer>

    <div class="button-container">
      <button
        mat-button
        color="warn"
        [disabled]="!isAbleToCancel()"
        (click)="cancelUnfinishedBooking()"
      >
        {{ 'button-bar-for-continue-booking.button.cancel' | translate }}
      </button>

      <lib-spacer [height]="10"></lib-spacer>

      <button
        mat-flat-button
        color="primary"
        class="submit-button"
        [disabled]="!data?.bookingConfigUrl?.length"
        (click)="continueBooking()"
      >
        {{ 'button-bar-for-continue-booking.button.continue' | translate }}
      </button>
    </div>
  </div>
</div>
<mat-progress-bar
  *ngIf="!isAbleToCancel()"
  mode="determinate"
  [value]="isAbleToCancelProgress"
></mat-progress-bar>
